import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/image/icon/icon_hint@2x.png'


const _hoisted_1 = { id: "argeement" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "ご注意ください")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "ご注文の際に検品オプションを選択頂いた場合、当社の検品標準により検品を行います。"),
  /*#__PURE__*/_createElementVNode("p", null, "不良品と判断される場合、ご指定頂いた不良品の対応方式に従って「返品返金」OR 「交換」を行います。"),
  /*#__PURE__*/_createElementVNode("p", null, "但し、当社で不良品と判断されたものの、販売サイトまたはショップに対して返品できないため返品不可になる場合がありますので予めご了承下さい。 （発生確率が約0~0.1%程度） ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt_20" }, [
  /*#__PURE__*/_createElementVNode("p", null, "その場合、当該不良品が返品不可不良品となります。")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt_20" }, [
  /*#__PURE__*/_createElementVNode("p", null, "返品不可不良品に対して、【在庫管理】メニュー で廃棄処理を依頼するか、"),
  /*#__PURE__*/_createElementVNode("p", null, "お客様の許可を得た上で、良品としてお客様に配送するか、"),
  /*#__PURE__*/_createElementVNode("p", null, "いずれかの処理方法を選択することができます。")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt_20" }, [
  /*#__PURE__*/_createElementVNode("p", null, "当社で廃棄処理を依頼する場合、お客様において当該商品の所有権が放棄されたものとみなし、ショップから商品代金の返金はなされませんので予めご了承ください。")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt_20" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※以下のいずれかに該当する場合は返品不可不良品となる可能性があります。"),
  /*#__PURE__*/_createElementVNode("p", null, "・お客様の検品要求が常に厳しく、ショップ側が不良品と認められない場合"),
  /*#__PURE__*/_createElementVNode("p", null, "・ショップ側は7日間無条件返品サービスを提供してない場合"),
  /*#__PURE__*/_createElementVNode("p", null, "・お客様都合により返品受付期間内（商品到着後7日以内）に返品要求を提出してない場合")
], -1)
const _hoisted_9 = { class: "mt_20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "※返品不可不良品の発生を回避する方法については、下記の内容をご参照下さい。", -1)
const _hoisted_11 = {
  key: 0,
  href: "https://s.theckb.com/d2c/article/2/78?source=shopcart",
  target: "_target"
}
const _hoisted_12 = {
  key: 1,
  href: "https://s.theckb.com/b2b/article/2/78?source=shopcart",
  target: "_target"
}

import { ref } from 'vue'
import { isD2C } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  visiable: {
    type: Boolean,
    default: false
  }
},
  emits: ['acceptArgeement', 'closeArgeement'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const countDown = ref(5) // 倒计时
const disabledBtn = ref(true) // 是否禁用按钮

const timer = ref()

const closeModal = () => {
  clearInterval(timer.value)
  countDown.value = 5
  emits('closeArgeement', false)
  disabledBtn.value = true
}
// 倒计时
const sendCode = () => {
  clearInterval(timer.value)
  countDown.value = 5
  timer.value = setInterval(() => {
    countDown.value--
    if (countDown.value === 0) {
      clearInterval(timer.value)
      disabledBtn.value = false
    }
  }, 1000)
}

expose({ sendCode })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "model-value": props.visiable,
      width: "600px",
      "custom-class": "argeementModal",
      onClose: closeModal,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: disabledBtn.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => ( emits('acceptArgeement'))),
            class: "confirmBtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('我确认并同意以上内容')) + " ", 1),
              _withDirectives(_createElementVNode("span", null, "（" + _toDisplayString(countDown.value + 's') + "）", 513), [
                [_vShow, disabledBtn.value]
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, [
              (_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("a", _hoisted_11, "https://s.theckb.com/d2c/article/2/78"))
                : (_openBlock(), _createElementBlock("a", _hoisted_12, "https://s.theckb.com/b2b/article/2/78"))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})